import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
  HubHookFormInput
} from "../../components";
import { usePostCreateIndustry, usePutUpdateIndustry } from "../../hooks";
import { useDialogContext } from "../HubDialogWrapper";

const IndustryContent = ({ allIndustries = [] }) => {
  const {
    mutate: postCreateIndustry,
    isLoading: isCreating,
    isSuccess: createSuccess,
  } = usePostCreateIndustry();

  const {
    mutate: putUpdateIndustry,
    isLoading: isUpdating,
    isSuccess: updateSuccess,
  } = usePutUpdateIndustry();

  const { onClose, open: industryId } = useDialogContext();
  
  // If industryId is a number, we're editing; if true (boolean), we're creating
  const isEditing = typeof industryId === 'number';
  const industry = isEditing ? allIndustries?.find(ind => ind.id === industryId) : null;
  
  const isLoading = isCreating || isUpdating;
  const isSuccess = createSuccess || updateSuccess;

  useEffect(() => {
    isSuccess && onClose();
  }, [isSuccess, onClose]);

  const onSubmit = (formData) => {
    const payload = {
      ...(isEditing && { id: industry?.id }),
      name: formData.name,
    };

    (isEditing ? putUpdateIndustry : postCreateIndustry)(payload);
  };

  const defaultValues = {
    name: isEditing ? (industry?.label || industry?.name || "") : ""
  };

  const title = isEditing ? "Edit Industry" : "Create a New Industry";
  const subtitle = isEditing 
    ? "Update the industry name below"
    : "Use the field below to create a new industry";
  const buttonLabel = isEditing ? "Update Industry" : "Create Industry";
  const placeholder = isEditing ? undefined : "ex. Mining";

  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit} defaultValues={defaultValues}>
        <Stack gap="35px" alignItems="center">
          <Stack alignItems="center">
            <Typography variant="h6">{title}</Typography>
            <Typography variant="caption">
              {subtitle}
            </Typography>
          </Stack>
          <Stack gap="15px" width="100%">
            <HubHookFormInput 
              name="name" 
              label="Industry Name" 
              placeholder={placeholder}
              required 
            />
          </Stack>
          <HubCancelSubmitGroup
            disabled={isLoading}
            isLoading={isLoading}
            label={buttonLabel}
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default IndustryContent;